import { decodeToken, isExpired } from 'react-jwt';

export function getToken() {
    const params = document.URL.split('/').pop();
    let token = '';

    if (params.includes('id_token')) {
        let splittedParams = params.split('&');

        splittedParams = splittedParams.reduce((result, param) => {
            const [key, value] = param.split('=');

            result[key] = value;

            return result;
        }, {});

        token = splittedParams.id_token;
    }

    return token || localStorage.getItem('token');
}

export function checkTfpSupport(tfp) {
    return (tfp || '').toLowerCase().includes('suporte');
}

export function getDecodedToken() {
    const token = getToken();

    if (token) {
        const decodedToken = decodeToken(token);

        if (checkTfpSupport(decodedToken.tfp)) {
            const { upn: email } = decodeToken(decodedToken.idp_access_token);

            decodedToken.email = email;
        }

        if (decodedToken.emails) {
            const email = typeof decodedToken.emails === 'string' ? decodedToken.emails : decodedToken.emails[0];

            decodedToken.email = email;
        }

        return decodedToken;
    }

    return undefined;
}

export function checkIsSupport() {
    const { tfp } = getDecodedToken();

    return checkTfpSupport(tfp);
}

export function logout() {
    const { tfp } = getDecodedToken() || {};

    const redirectURL = checkTfpSupport(tfp)
        ? process.env.REACT_APP_ROUTE_REDIRECT_LOGOUT_SUPORTE
        : process.env.REACT_APP_ROUTE_REDIRECT_LOGOUT_LOGIN;

    localStorage.removeItem('token');

    window.location.href = `${process.env.REACT_APP_LOGOUT_URL}&post_logout_redirect_uri=${redirectURL}`;
}

export function isLogged() {
    const token = getToken();

    if (token) {
        const decodedToken = decodeToken(token);
        const tokenExpired = isExpired(token);

        if (decodedToken.iss && decodedToken.iss.includes(process.env.REACT_APP_ISS_DOMAIN) && !tokenExpired) {
            localStorage.setItem('token', token);

            return true;
        }
    }

    logout();

    return false;
}
